import { useImperativeHandle as commonUseImperativeHandle } from "packages/react";

export const useImperativeHandle = commonUseImperativeHandle;
